//show dropdown menu on hover
document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth < 990) return;

  const menuItems = document.querySelectorAll('header-menu details');

  menuItems.forEach(function (details) {
    details.addEventListener('mouseenter', function () {
      details.setAttribute('open', true);

      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    });

    details.addEventListener('mouseleave', function () {
      details.removeAttribute('open');

      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });
});